import React from 'react'

interface IProps {
    onClick: () => void
    type: 'button' | 'submit' | 'reset' | undefined
    children: React.ReactNode
    title?: string
    style?: object
}

export default function ButtonIcon(props: IProps): React.ReactElement {
    return (
        <button
            type={props.type}
            onClick={props.onClick}
            className='button-icon'
            style={props.style}
            title={props.title}
        >
            {props.children}
        </button>
    )
}
